import React from "react";
import {Brands} from "@core-ui/utility";
import {Icon} from "../components/Icon";
import {IconContainerProps} from "../types";

const InfoCircleIconSVG = (
  <svg fill="none" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
    <path
      clipRule="evenodd"
      d="M7 1.5C3.96243 1.5 1.5 3.96243 1.5 7C1.5 10.0376 3.96243 12.5 7 12.5C10.0376 12.5 12.5 10.0376 12.5 7C12.5 3.96243 10.0376 1.5 7 1.5ZM0.5 7C0.5 3.41015 3.41015 0.5 7 0.5C10.5899 0.5 13.5 3.41015 13.5 7C13.5 10.5899 10.5899 13.5 7 13.5C3.41015 13.5 0.5 10.5899 0.5 7Z"
      fill="#333333"
      fillRule="evenodd"
    />
    <path
      d="M6.97911 4.98025C7.14716 4.9867 7.31134 4.92875 7.43811 4.81825C7.49728 4.76524 7.54407 4.69987 7.57518 4.62678C7.60628 4.55368 7.62094 4.47464 7.61811 4.39525C7.62072 4.31515 7.60599 4.23543 7.57492 4.16156C7.54386 4.08769 7.49719 4.0214 7.43811 3.96725C7.31248 3.85439 7.14786 3.79485 6.97911 3.80125C6.81022 3.79513 6.64558 3.85503 6.52011 3.96825C6.46116 4.02229 6.41457 4.08841 6.3835 4.1621C6.35244 4.23579 6.33764 4.31532 6.34011 4.39525C6.34011 4.56925 6.40011 4.71025 6.52011 4.81825C6.64688 4.92875 6.81106 4.9867 6.97911 4.98025ZM7.49211 10.1732V5.75425H6.45711V10.1732H7.49211Z"
      fill="#333333"
    />
  </svg>
);

const brandIconSVGs = {
  [Brands.Athleta]: InfoCircleIconSVG,
  [Brands.BananaRepublic]: InfoCircleIconSVG,
  [Brands.BananaRepublicFactoryStore]: InfoCircleIconSVG,
  [Brands.Gap]: InfoCircleIconSVG,
  [Brands.GapFactoryStore]: InfoCircleIconSVG,
  [Brands.OldNavy]: InfoCircleIconSVG,
  crossBrand: InfoCircleIconSVG,
};

export const InfoCircleIcon = (props: IconContainerProps): JSX.Element => (
  <Icon {...props} brandIconSVGs={brandIconSVGs} />
);
